import { render, staticRenderFns } from "./JdiCodeBlock.vue?vue&type=template&id=66e2b4fa&scoped=true&"
import script from "./JdiCodeBlock.vue?vue&type=script&lang=ts&"
export * from "./JdiCodeBlock.vue?vue&type=script&lang=ts&"
import style0 from "./JdiCodeBlock.vue?vue&type=style&index=0&id=66e2b4fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e2b4fa",
  null
  
)

export default component.exports